<template>
  <AdblockTopbar />
  <div class="px-4 sm:px-6 lg:px-16 max-w-screen-xl lg:mx-auto">
    <HeaderApp />

    <template v-if="true">
      <div class="text__view flex flex-col justify-center text-center mb-16">
        <h1 class="font-semibold text-2xl my-5">
          {{ calendar_title_subtitle.title }}
        </h1>
        <p class="leading-6 max-w-5xl mx-auto">
          {{ calendar_title_subtitle.subtitle }}
        </p>
      </div>
      <template v-if="['free'].includes(roleUser)">
        <UpgradePlans :text="' the eCommerce calendar'" />
        <div
          class="lock mt-5 calendar__wrapper grid-cols-1 lg:grid-cols-3 p-4 lg:py-10 items-start justify-items-center"
        >
          <div>
            <v-date-picker
              ref="calendar"
              locale="en-us"
              mode="date"
              :model-config="modelConfig"
              :attributes="attrs"
              v-model="dateSelect"
            />
          </div>
          <div
            class="text__calendar flex flex-col gap-5 bg-gradient-to-r from-white to-indigo-300 p-5 w-full"
          >
            <div class="flex flex-col gap-1 py-3 justify-center text-center">
              <h1 class="text-lg font-semibold">
                {{ findDate.NAME_OF_THE_DAY }}
              </h1>
              <p class="text-sm">{{ findDate.MONTH }} {{ findDate.DATE }}</p>
            </div>
            <div class="px-3">
              <p class="text-sm leading-5">
                {{ findDate.DESCRIPTION }}
              </p>
            </div>
            <div class="flex items-center justify-center flex-col gap-3 py-3">
              <img
                class="w-16"
                src="../../assets/images/placeholder.png"
                alt=""
              />
              <h3 class="font-semibold text-center">{{ findDate.REGION }}</h3>
            </div>
          </div>
          <div>
            <VideoTemplate
              v-if="findDate.TYPE === 'video'"
              :src="findDate.LINK"
              :key="findDate.NAME_OF_THE_DAY"
            />
            <img v-else :src="findDate.LINK" alt="" />
          </div>
        </div>
      </template>
      <template v-else>
        <div
          class="calendar__wrapper grid-cols-1 lg:grid-cols-3 p-4 lg:py-10 items-start justify-items-center"
        >
          <div>
            <v-date-picker
              ref="calendar"
              locale="en-us"
              mode="date"
              :model-config="modelConfig"
              :attributes="attrs"
              v-model="dateSelect"
            />
          </div>
          <div
            class="text__calendar flex flex-col gap-5 bg-gradient-to-r from-white to-indigo-300 p-5 w-full"
          >
            <div class="flex flex-col gap-1 py-3 justify-center text-center">
              <h1 class="text-lg font-semibold">
                {{ findDate.NAME_OF_THE_DAY }}
              </h1>
              <p class="text-sm">{{ findDate.MONTH }} {{ findDate.DATE }}</p>
            </div>
            <div class="px-3">
              <p class="text-sm leading-5">
                {{ findDate.DESCRIPTION }}
              </p>
            </div>
            <div class="flex items-center justify-center flex-col gap-3 py-3">
              <img
                class="w-16"
                src="../../assets/images/placeholder.png"
                alt=""
              />
              <h3 class="font-semibold text-center">{{ findDate.REGION }}</h3>
            </div>
          </div>
          <div>
            <VideoTemplate
              v-if="findDate.TYPE === 'video'"
              :src="findDate.LINK"
              :key="findDate.NAME_OF_THE_DAY"
            />
            <img v-else :src="findDate.LINK" alt="" />
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import { computed, ref, onMounted, onBeforeMount } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import HeaderApp from "@/components/Header";
import AdblockTopbar from "@/components/AdblockTopbar";
import VideoTemplate from "@/components/VideoTemplate.vue";
import UpgradePlans from "@/components/UpgradePlans";

export default {
  components: { HeaderApp, AdblockTopbar, UpgradePlans, VideoTemplate },
  setup() {
    const store = useStore();
    const router = useRouter();
    onBeforeMount(async () => {
      const status = computed(() => store.state.status);
      if (!status.value) {
            console.log("1")

        router.push("/pricing");
      }
    });

    const calendar = ref(null);
    const dateSelect = ref(null);
    const modelConfig = ref({
      type: "string",
      mask: "MMMM-DD", // Uses 'iso' if missing
    });
    const attrs = ref([]);
    const moveCalendarUp = async () => {
      await calendar.value.move(1);
    };
    const moveCalendarDown = async () => {
      await calendar.value.move(-1);
    };
    const findDate = computed(() => {
      let splitDate = dateSelect.value ? dateSelect.value.split("-") : "";
      return dateSelect.value
        ? dates.value.find(
            (element) =>
              element.MONTH == splitDate[0] && element.DATE == splitDate[1]
          )
        : dates.value[0];
    });
    const roleUser = computed(() => store.state.role);
    const calendar_title_subtitle = computed(
      () => store.state.calendarTitleSubtitle
    );
    const dates = computed(() => store.state.specialDates);

    const addDatesToCalendar = () => {
      const date = new Date();
      const year = date.getFullYear();
      dates.value.forEach((element) => {
        attrs.value.push({
          key: element.NAME_OF_THE_DAY,
          highlight: "indigo",
          dates: new Date(`${element.MONTH} ${element.DATE}, ${year}`),
        });
      });
    };
    onMounted(async () => {
      addDatesToCalendar();
    });
    return {
      dates,
      calendar_title_subtitle,
      moveCalendarUp,
      moveCalendarDown,
      dateSelect,
      calendar,
      attrs,
      roleUser,
      modelConfig,
      findDate,
    };
  },
};
</script>

<style scoped>
.lock {
  filter: blur(12px);
  pointer-events: none;
}
.calendar__wrapper {
  @apply grid gap-y-10 gap-x-10 bg-gray-300;
  min-width: 320px;
  border-radius: 20px;
}
.text__calendar {
  background-image: linear-gradient(
    to bottom right,
    rgb(255, 255, 255),
    rgba(102, 126, 234, 0.342)
  );
  border-radius: 18px;
}
.vc-container {
  background-color: transparent;
  border: none;
}
</style>
